import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { PLANS } from "@/lib/content";

export default function Pricing({ yearly, setYearly, onSelect, ctaLabel = "Commencer, 0€ aujourd'hui", activePlan, noTrial = false }) {
  return (
    <div>
      <div className="flex items-center justify-center gap-4 mb-10">
        <span className={`text-sm font-medium ${!yearly ? "text-slate-900" : "text-slate-400"}`}>Mensuel</span>
        <Switch checked={yearly} onCheckedChange={setYearly} data-testid="pricing-billing-toggle" />
        <span className={`text-sm font-medium ${yearly ? "text-slate-900" : "text-slate-400"}`}>
          Annuel <span className="text-emerald-600 font-semibold">2 mois offerts</span>
        </span>
      </div>

      <div className="grid md:grid-cols-3 gap-6 items-start">
        {PLANS.map((p) => {
          const price = yearly ? Math.round(p.yearly / 12) : p.monthly;
          const isActive = activePlan === p.key;
          return (
            <div
              key={p.key}
              data-testid={`plan-card-${p.key}`}
              className={`relative rounded-2xl bg-white p-7 border hover-lift ${
                p.highlight ? "border-primary shadow-xl shadow-blue-100 md:-mt-4 md:mb-4" : "border-border"
              }`}
            >
              {p.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-white text-xs font-bold px-3 py-1 rounded-full tracking-wide">
                  LE PLUS CHOISI
                </div>
              )}
              <h3 className="font-display text-xl font-bold text-slate-900">{p.name}</h3>
              <p className="text-sm text-slate-500 mt-1">{p.tagline}</p>
              <div className="mt-5 flex items-baseline gap-1">
                <span className="font-display text-4xl font-extrabold text-slate-900">{price}€</span>
                <span className="text-slate-500 text-sm">/mois HT</span>
              </div>
              <p className="text-xs text-emerald-700 font-medium mt-1">{noTrial ? `${price}€/mois, facturé dès aujourd'hui` : `0€ aujourd'hui, puis ${price}€/mois après 7 jours`}</p>
              {yearly && <p className="text-xs text-slate-400 mt-0.5">facturé {p.yearly}€/an</p>}
              <ul className="mt-6 space-y-3">
                {p.features.map((f, i) => (
                  <li key={i} className="flex gap-2.5 text-sm text-slate-600">
                    <Check className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" strokeWidth={3} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Button
                onClick={() => onSelect(yearly ? p.lookupYear : p.lookup, p.key)}
                disabled={isActive}
                className="w-full mt-7 rounded-full"
                variant={p.highlight ? "default" : "outline"}
                data-testid={`plan-select-${p.key}`}
              >
                {isActive ? "Votre formule actuelle" : ctaLabel}
              </Button>
              <p className="text-center text-xs text-slate-400 mt-2">Résiliable à tout moment</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
